import {
  ChangeDetectorRef,
  Component,
  inject,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-save-button',
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './save-button.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./save-button.scss'],
})
export class SaveButton {
  private readonly cdr = inject(ChangeDetectorRef);

  isEditMode = input<boolean>(false);
  enabled = input<boolean>(true);

  protected isSaving = false;
  protected isSuccess = false;

  get buttonLabel(): string {
    if (this.isSaving) {
      return this.isSuccess ? 'Modifié' : 'Enregistrement...';
    }
    if (this.isSuccess) {
      return this.isEditMode() ? 'Modifié' : 'Créé';
    }
    return this.isEditMode() ? 'Modifier' : 'Créer';
  }
  startSaving(): void {
    this.isSaving = true;
    this.cdr.detectChanges();
  }

  stopSaving(success: boolean): void {
    this.isSaving = false;
    this.isSuccess = success;
    this.cdr.detectChanges();
  }
}
